export default __webpack_public_path__ + "static/media/ringring.278d7816.mp3";